import {InjectionToken} from '@angular/core';
import {TexfabCarpetLastModified} from '@domain/texfab/texfab-carpet-last-modified';
import {TexfabSalesLastModified} from '@domain/texfab/texfab-sales-last-modified';
import {TexfabTuftingLastModified} from '@domain/texfab/texfab-tufting-last-modified';
import {TexfabWeavingLastModified} from '@domain/texfab/texfab-weaving-last-modified';
import {Observable} from 'rxjs';

export const TEXFAB = new InjectionToken<Texfab>('Texfab');

export interface Texfab {
  getCarpetLastModified(): Observable<TexfabCarpetLastModified>;

  getWeavingLastModified(): Observable<TexfabWeavingLastModified>;

  getTuftingLastModified(): Observable<TexfabTuftingLastModified>;

  getSalesLastModified(): Observable<TexfabSalesLastModified>;
}
